import { render } from "./Ulaz.vue?vue&type=template&id=9977af72&scoped=true"
import script from "./Ulaz.vue?vue&type=script&lang=js"
export * from "./Ulaz.vue?vue&type=script&lang=js"

import "./Ulaz.vue?vue&type=style&index=0&id=9977af72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9977af72"]])

export default __exports__